//@flow
import BP from './src/info-bar-container';
export default BP;